webpackJsonp([3],{

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(594)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(634),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-18145f8f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 519:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSubmitProblemList;
/* harmony export (immutable) */ __webpack_exports__["b"] = getSubmitProblemByGuid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_fetch__ = __webpack_require__(13);


function getSubmitProblemList(isUsed) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/get_submit_problem_list',
    params: {
      isUsed: isUsed
    },
    method: 'get'
  });
}

function getSubmitProblemByGuid(guid) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_fetch__["a" /* default */])({
    url: '/get_submit_problem_by_guid',
    params: {
      guid: guid
    },
    method: 'get'
  });
}

/***/ }),

/***/ 530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_main_js__ = __webpack_require__(531);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__src_main_js__["a" /* default */]);

/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(34);


var ProblemUserSubmitDlgConstructor = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend(__webpack_require__(624));

var instance = void 0;

var problemUserSubmitDlg = function problemUserSubmitDlg(options) {
  options = options || {};
  if (!instance) {
    instance = new ProblemUserSubmitDlgConstructor({
      data: options,
      store: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */]
    });
    instance.vm = instance.$mount();
    document.body.appendChild(instance.vm.$el);
  }

  instance.vm.guid = options.guid;
  instance.vm.show = true;
  return instance.vm;
};

/* harmony default export */ __webpack_exports__["a"] = (problemUserSubmitDlg);

/***/ }),

/***/ 540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_problemUserSubmitDlg__ = __webpack_require__(530);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      cols: [{
        prop: 'id',
        label: 'id',
        width: 80
      }, {
        prop: 'guid',
        label: 'guid',
        width: 100
      }, {
        prop: 'userGuid',
        label: 'userGuid',
        width: 100
      }, {
        prop: 'keywords',
        label: '关键词',
        width: 100
      }, {
        prop: 'title',
        label: '标题',
        width: 100
      }, {
        prop: 'content',
        label: '内容',
        width: 100
      }, {
        prop: 'imgs',
        label: '关键词',
        width: 150
      }, {
        prop: 'date',
        label: '提交日期',
        width: 150
      }, {
        prop: 'isUsed',
        label: '是否采纳',
        width: 150
      }]
    };
  },

  props: ['tableData'],
  computed: {
    tabH: function tabH() {
      return this.winH - (this.search ? this.search.getHeight() : 80) - 88;
    }
  },
  created: function created() {
    console.log('----11----');
  },

  methods: {
    edit: function edit(guid) {
      console.log('审核用户上传的题目->edit guid = ', guid);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__components_problemUserSubmitDlg__["a" /* default */])({
        guid: guid
      });
    }
  }
});

/***/ }),

/***/ 543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_api_prepareProblemUser_js__ = __webpack_require__(519);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      title: '审核用户提交的题目',
      show: false,
      guid: '',
      isEditData: 0,
      pInfo1: {
        id: 0,
        guid: ''
      }
    };
  },

  computed: {
    title: function title() {}
  },
  watch: {
    show: function show(val) {}
  },
  mounted: function mounted() {
    console.log('----here mounted guid=----');
    this.loadData();
  },

  methods: {
    closeDlg: function closeDlg() {
      this.show = false;
    },
    showMsg: function showMsg(msg) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'warning';

      this.$notify({
        title: '审核题目',
        message: msg,
        type: type
      });
    },
    loadData: function loadData() {
      var _this = this;

      console.log('----loadData guid=----' + this.guid);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_api_prepareProblemUser_js__["b" /* getSubmitProblemByGuid */])(this.guid).then(function (res) {
        var data = res.data;
        console.log('----data=----' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
        if (data.isOk) {
          console.log('user tm', res.data.data);
        }
      }).catch(function (err) {
        _this.showMsg(err);
      });
    }
  }
});

/***/ }),

/***/ 558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_prepareProblemTableUser_prepareProblemTableUser__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_prepareProblemTableUser_prepareProblemTableUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_prepareProblemTableUser_prepareProblemTableUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_api_prepareProblemUser_js__ = __webpack_require__(519);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      value: '',
      dshProblemListUser: ''
    };
  },

  computed: {},
  created: function created() {
    var _this = this;

    console.log('----取未审核过的用户出的题----');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__api_api_prepareProblemUser_js__["a" /* getSubmitProblemList */])(0).then(function (res) {
      var data = res.data;
      console.log('----data=----' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      if (data.isOk) {
        _this.dshProblemListUser = data.data;
      }
      console.log('----this.dshProblemListUser=----' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.dshProblemListUser));
    }).catch(function (err) {
      _this.showMsg(err);
      _this.loading = false;
    });
  },
  mounted: function mounted() {},

  components: {
    prepareProblemTableUser: __WEBPACK_IMPORTED_MODULE_1__components_prepareProblemTableUser_prepareProblemTableUser___default.a
  },
  methods: {}
});

/***/ }),

/***/ 567:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, ".centerdiv[data-v-18145f8f]{height:auto;text-align:center}", "", {"version":3,"sources":["E:/mywork/math/mathManager/src/pages/prepareProblemListUser.vue"],"names":[],"mappings":"AACA,4BACE,YAAa,AACb,iBAAmB,CACpB","file":"prepareProblemListUser.vue","sourcesContent":["\n.centerdiv[data-v-18145f8f]{\n  height: auto;\n  text-align: center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"prepareProblemTableUser.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(253)(true);
// imports


// module
exports.push([module.i, ".h20{height:20px}", "", {"version":3,"sources":["E:/mywork/math/mathManager/src/components/problemUserSubmitDlg/src/main.vue"],"names":[],"mappings":"AACA,KACE,WAAa,CACd","file":"main.vue","sourcesContent":["\n.h20{\n  height: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(567);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("33683522", content, true);

/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(578);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("0c18f8a4", content, true);

/***/ }),

/***/ 610:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(583);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(254)("48989dcf", content, true);

/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(605)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(645),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(610)
}
var Component = __webpack_require__(96)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(650),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 634:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centerdiv"
  }, [_c('h2', [_vm._v("用户出题列表")]), _vm._v(" "), _c('prepare-problem-table-user', {
    attrs: {
      "tableData": _vm.dshProblemListUser
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 645:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "height": _vm.tabH
    }
  }, [_vm._l((_vm.cols), function(col) {
    return _c('el-table-column', {
      key: col.prop,
      attrs: {
        "prop": col.prop,
        "label": col.label,
        "width": col.width,
        "show-overflow-tooltip": ""
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    key: "edit",
    attrs: {
      "label": "审核",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.edit(scope.row.guid)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])]
      }
    }])
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "size": "full",
      "destroyed-on-close": "true"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "element-loading-text": _vm.isEditData === 0 ? '修改保存中。。。' : '新增保存中。。。'
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form', {
    ref: "pInfo1",
    attrs: {
      "model": _vm.pInfo1,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    staticClass: "h20",
    attrs: {
      "label": "guid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "guid,修改时用"
    },
    model: {
      value: (_vm.pInfo1.guid),
      callback: function($$v) {
        _vm.pInfo1.guid = $$v
      },
      expression: "pInfo1.guid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1
    }
  }, [_vm._v("\n         \n      ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-row', [_c('span', [_vm._v("题目内容")])])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/3.e393af0a3925a96a872a.js